import { Icon } from '@iconify/react';
import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import IconLogo from 'src/assets/white-logo.svg?react';
import { ConnectButton } from '../Header/ConnectButton.tsx';
import { UIButton } from '../UI/UIButton.tsx';

type NavItem = {
  name: string;
  to?: string;
  href?: string;
  icon: string;
  disabled?: boolean;
};

const NAV_ITEMS: NavItem[] = [
  {
    name: 'Towards AGI',
    to: '/agi',
    icon: 'fa6-solid:fire',
  },
  {
    name: 'AI Marketplace',
    to: '/agents',
    icon: 'fa6-solid:store',
  },
  {
    name: 'My Agents',
    to: '/my-bots',
    icon: 'fa6-solid:robot',
    disabled: true,
  },
  {
    name: 'Build AI Agent',
    to: '/build-ai-agent',
    icon: 'fa6-solid:pen',
  },
];

const NavElement = ({ item }: { item: NavItem }) => {
  const commonContent = (
    <>
      <div className="-mt-[2px] mr-2 flex h-[18px] w-[18px] items-center justify-center">
        <Icon icon={item.icon} />
      </div>
      <span className="sm:text-md mr-6 text-lg">{item.name}</span>
      {item.disabled && (
        <span className="ml-auto rounded-xl bg-white px-2 py-0.5 text-xs text-black">soon</span>
      )}
    </>
  );

  if (item.to) {
    return (
      <NavLink
        key={item.to}
        to={item.disabled ? '#' : item.to}
        className={({ isActive }) =>
          `flex cursor-pointer items-center px-6 py-3 text-xs xl:text-base ${
            item.disabled || !isActive ? 'opacity-40' : ''
          }`
        }
      >
        {commonContent}
      </NavLink>
    );
  }

  return (
    <a
      key={item.href}
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex cursor-pointer items-center px-6 py-3 ${item.disabled ? 'opacity-40' : ''}`}
    >
      {commonContent}
    </a>
  );
};

export const LeftSidebar = () => {
  return (
    <div className="hidden h-full flex-col lg:flex">
      {NAV_ITEMS.map((item) => (
        <NavElement key={item.to || item.href} item={item} />
      ))}
      <div className="mb-6 ml-6 mt-auto flex items-center gap-4">
        <a href="https://x.com/0xAgix" target="_blank">
          <img className="w-10" src="/images/x-icon.png" />
        </a>
        <a href="https://t.me/aigentx_group" target="_blank">
          <img className="w-10" src="/images/tg-icon.png" />
        </a>
      </div>
    </div>
  );
};

export const DrawerSidebar = ({ isOpen, close }: { isOpen: boolean; close: () => void }) => {
  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      close();
    }
  }, [location]);

  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity duration-300 ${
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        } lg:hidden`}
        onClick={close}
      ></div>

      <div
        className={`fixed inset-0 z-50 transform bg-[#0E1012] text-white transition-transform duration-300 sm:inset-y-0 sm:left-0 sm:w-80 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:hidden`}
      >
        <div className="absolute left-6 right-6 top-4 flex items-center justify-between">
          <a href="http://agint.xyz/" target="_blank">
            <IconLogo />
          </a>
          <button onClick={close}>
            <Icon icon="fa6-solid:xmark" className="h-6 w-6" />
          </button>
        </div>

        <nav className="mt-16">
          {NAV_ITEMS.map((item) => (
            <NavElement key={item.to || item.href} item={item} />
          ))}
        </nav>

        <div className="mt-4 flex flex-col items-center gap-4 px-6 sm:hidden">
          {/*<ConnectTwitter />*/}
          <NavLink to="/bridge">
            <UIButton buttonColor="blue">Bridge</UIButton>
          </NavLink>
          <ConnectButton />
        </div>
      </div>
    </>
  );
};
